const MAX_LONG_SIDE = 1600;
const JPEG_QUALITY = 0.82;

function encodedBlob(canvas: HTMLCanvasElement, type: string, quality?: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob === null) reject(new Error('image_encode_failed'));
        else resolve(blob);
      },
      type,
      quality,
    );
  });
}

function uploadName(name: string, type: string): string {
  const stem = name.replace(/\.[^.]*$/, '') || 'screenshot';
  return `${stem}.${type === 'image/png' ? 'png' : 'jpg'}`;
}

/** Shrink screenshots before they cross the network. PNG survives only when it is smaller. */
export async function prepareHuddleScreenshot(file: File): Promise<File> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(1, MAX_LONG_SIDE / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (context === null) throw new Error('image_canvas_unavailable');

    // JPEG has no alpha channel, so make transparent screenshots readable.
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, width, height);
    context.drawImage(bitmap, 0, 0, width, height);

    const jpeg = await encodedBlob(canvas, 'image/jpeg', JPEG_QUALITY);
    let chosen = jpeg;
    if (file.type === 'image/png') {
      const png = await encodedBlob(canvas, 'image/png');
      if (png.size < jpeg.size) chosen = png;
    }

    return new File([chosen], uploadName(file.name, chosen.type), {
      type: chosen.type,
      lastModified: file.lastModified,
    });
  } finally {
    bitmap.close();
  }
}
